import { render, staticRenderFns } from "./MainHeaderNotifications.vue?vue&type=template&id=3579203c&"
import script from "./MainHeaderNotifications.vue?vue&type=script&lang=js&"
export * from "./MainHeaderNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports